import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
import CollapseHeader from "../../../core/common/collapse-header";
import Table from "../../../core/common/dataTable/index";
import GridView from "../../../core/common/GridView";
import { toast } from "react-toastify";
import { all_routes } from "../../router/all_routes";
import {
  createTarget,
  deleteTarget,
  getIncentiveByUser,
  getAllIncentives,
  Incentive,
  IncentiveFallback,
  exportTargetExcel,
  exportTargetPDF,
  exportSelectedTargetExcel,
  exportSelectedTargetPDF,
  deleteTargetBulk,
} from "../../../api/target";
import { useSelector } from "react-redux";
import { RootState } from "../../../core/data/redux/store";
import { fetchUsersByClientId } from "../../../api/todo";
import { highlightMatch } from "../../../core/common/highlightmatch";
import { User } from "../../../api/proposal";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { initialSettings } from "../../../core/common/selectoption/selectoption";
import { Dropdown, Menu, Button, Pagination } from "antd";
import { DownOutlined } from "@ant-design/icons";
import {
  validateSalary,
  validateSelect,
  validateIncentivePercentage,
  validateUserSelect,
} from "../../../api/leadValidation";
import type { UserSelectErrors } from "../../../api/leadValidation";
import CountUp from "react-countup";
import KpiCard from "../../../core/common/KPIcard";
import Tip from "../../../core/common/tooltip";
import ColumnManagement from "../../../core/common/ColumnManagement";
import { TargetDetail } from "../../../api/dashboard";
import SubmoduleHoverCard2 from "../../../core/common/SubCard2Button";
import ScrollToTop from "../../../core/common/ScrollToTop";
import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";

const TargetPage = () => {
  const [error, setError] = useState<string | null>(null);
  const [dataSource, setDataSource] = useState<Incentive[]>([]);
  const [orderedData, setOrderedData] = useState<Incentive[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [newTarget, setNewTarget] = useState<number>(0);
  const [newUserId, setNewUserId] = useState<string>("");
  const userRole = useSelector((state: RootState) => state.auth.role);
  const route = all_routes;
  const [newIncentivePercentage, setNewIncentivePercentage] =
    useState<number>(0);
  const [editTarget, setEditTarget] = useState<Incentive | null>(null);
  const [editTargetValue, setEditTargetValue] = useState<number>(0);
  const [editUserId, setEditUserId] = useState<string>("");
  const [editIncentivePercentage, setEditIncentivePercentage] =
    useState<number>(0);
  const [calculateUserId, setCalculateUserId] = useState<string>("");
  const [incentiveResult, setIncentiveResult] = useState<Incentive | null>(
    null
  );
  const [deleteTargetId, setDeleteTargetId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Date, Date] | null
  >(null);
  const [activeRangeLabel, setActiveRangeLabel] = useState("Last 30 Days");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [deleting, setDeleting] = useState(false);
  const [sortOption, setSortOption] = useState("recently_added");
  const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');
  const [saving, setSaving] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    {
      SI_no: true,
      user_name: true,
      salary: true,
      target: true,
      incentive_percentage: true,
      created_at: true,
      action: true,
    }
  );
  const defaultColumnOrder = [
    "user_name",
    "salary",
    "target",
    "incentive_target",
    "total_deal_value",
    "incentive_percentage",
    "incentive_achieved_amount",
    "calculated_incentive",
    "created_at",
    "action",
  ];

  // Column order state for drag and drop (only non-sticky columns)
  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("targetColumnKeys");
    if (saved) return JSON.parse(saved);
    return defaultColumnOrder;
  });

  // Hook for save prompt on navigation/refresh
  const { SaveModal } = useColumnOrderSave({
    columnKeys,
    localStorageKey: "targetColumnKeys",
    defaultOrder: defaultColumnOrder,
  });

  // Accordion toggle
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const handleAccordionToggle = (key: string) => {
    setOpenAccordion(openAccordion === key ? null : key);
  };

  // Filter search states
  const [filterUserSearch, setFilterUserSearch] = useState("");
  const [filterSalarySearch, setFilterSalarySearch] = useState("");
  const [filterTargetSearch, setFilterTargetSearch] = useState("");
  const [filterIncentiveSearch, setFilterIncentiveSearch] = useState("");
  const [filterDateSearch, setFilterDateSearch] = useState("");

  // Selected filter data arrays
  const [filterUsers, setFilterUsers] = useState<string[]>([]);
  const [filterSalaries, setFilterSalaries] = useState<string[]>([]);
  const [filterTargets, setFilterTargets] = useState<string[]>([]);
  const [filterIncentives, setFilterIncentives] = useState<string[]>([]);
  const [filterCreatedAts, setFilterCreatedAts] = useState<string[]>([]);
  const [alphaFilter, setAlphaFilter] = useState<string>("All");
  const [newTargetError, setNewTargetError] = useState<string | null>(null);

  const [newUserError, setNewUserError] = useState<string | null>(null);
  const [newPctError, setNewPctError] = useState<string | null>(null);

  const [editTargetError, setEditTargetError] = useState<string | null>(null);
  const [editUserError, setEditUserError] = useState<string | null>(null);
  const [editPctError, setEditPctError] = useState<string | null>(null);

  const [calculateUserError, setCalculateUserError] =
    useState<UserSelectErrors>({});
  const [calculating, setCalculating] = useState(false);
  useEffect(() => {
    const styleId = "animated-badge-keyframes";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
        @keyframes shine {
          0% {
            transform: skewX(-20deg) translateX(-150%);
          }
          50% {
             transform: skewX(-20deg) translateX(150%);
          }
          100% {
            transform: skewX(-20deg) translateX(150%);
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  useEffect(() => {
    if (newUserId) {
      const check = validateSelect(newUserId, "user");
      setNewUserError(check.valid ? null : check.message);
    }
  }, [newUserId]);

  // ADD THIS useEffect – it forces validation error to show immediately when modal opens
  useEffect(() => {
    // When "Add Target" modal is opened → show user error if no user selected
    const handleAddModalShow = () => {
      setNewTarget(0);
      setNewUserId("");
      setNewIncentivePercentage(0);

      // Force validation errors to appear right away
      setNewTargetError(
        validateSalary(0).valid ? null : validateSalary(0).message
      );
      setNewUserError(validateSelect("", "user").message); // ← THIS LINE IS KEY
      setNewPctError(
        validateIncentivePercentage(0).valid
          ? null
          : validateIncentivePercentage(0).message
      );
    };

    const modal = document.getElementById("add_target");
    modal?.addEventListener("show.bs.modal", handleAddModalShow);

    return () => {
      modal?.removeEventListener("show.bs.modal", handleAddModalShow);
    };
  }, []);

  // Fix Edit modal – show validation errors immediately when opened
  useEffect(() => {
    const handleEditModalShow = () => {
      if (!editTarget) return;

      // Pre-fill values (already done in onClick, but ensure validation runs)
      setEditTargetValue(editTarget.salary);
      setEditUserId(editTarget.user_id);
      setEditIncentivePercentage(editTarget.incentive_percentage || 0);

      // Force validation errors to appear right away
      const salaryCheck = validateSalary(editTarget.salary);
      const userCheck = validateSelect(editTarget.user_id, "user");

      setEditTargetError(salaryCheck.valid ? null : salaryCheck.message);
      setEditUserError(userCheck.valid ? null : userCheck.message);
    };

    const modal = document.getElementById("edit_target");
    modal?.addEventListener("show.bs.modal", handleEditModalShow);

    return () => {
      modal?.removeEventListener("show.bs.modal", handleEditModalShow);
    };
  }, [editTarget]);

  // Fix Calculate Incentive modal – show error on open
  useEffect(() => {
    const handleCalcModalShow = () => {
      setCalculateUserId("");
      const errors = validateUserSelect({ calculateUserId: "" });
      setCalculateUserError(errors); // This will show "Please select a user"
    };

    const modal = document.getElementById("calculate_incentive");
    modal?.addEventListener("show.bs.modal", handleCalcModalShow);

    return () => {
      modal?.removeEventListener("show.bs.modal", handleCalcModalShow);
    };
  }, []);

  // Reset filters
  const resetFilters = () => {
    setFilterUsers([]);
    setFilterSalaries([]);
    setFilterTargets([]);
    setFilterIncentives([]);
    setFilterCreatedAts([]);
    setFilterUserSearch("");
    setFilterSalarySearch("");
    setFilterTargetSearch("");
    setFilterIncentiveSearch("");
    setFilterDateSearch("");
  };

  // Common handler
  const handleFilterChange = (
    value: string,
    filterArray: string[],
    setFilterArray: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (filterArray.includes(value)) {
      setFilterArray(filterArray.filter((v) => v !== value));
    } else {
      setFilterArray([...filterArray, value]);
    }
  };

  const getUserName = (id: string) => {
    const user = users.find((u) => u.id === id);
    return user ? user.name : "Unknown";
  };

  const uniqueUsers = useMemo(
    () => Array.from(new Set(dataSource.map((d) => getUserName(d.user_id)))),
    [dataSource, users]
  );

  const uniqueSalaries = useMemo(
    () => Array.from(new Set(dataSource.map((d) => String(d.salary || "")))),
    [dataSource]
  );

  const uniqueTargets = useMemo(
    () => Array.from(new Set(dataSource.map((d) => String(d.target || "")))),
    [dataSource]
  );

  const uniqueIncentives = useMemo(
    () =>
      Array.from(
        new Set(dataSource.map((d) => String(d.incentive_percentage || "")))
      ),
    [dataSource]
  );

  const uniqueCreatedAts = useMemo(
    () =>
      Array.from(
        new Set(
          dataSource.map((d) =>
            d.created_at
              ? new Date(d.created_at).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              : ""
          )
        )
      ),
    [dataSource]
  );

  const handleColumnToggle = (key: string) => {
    setVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const clientId = useSelector((state: RootState) => state.auth.client_id);
  const [showResultModal, setShowResultModal] = useState(false);
  useEffect(() => {
    loadData();
  }, [clientId]);

  // Make modals draggable
  useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      // Reset position when modal is shown
      const resetPosition = () => {
        // Reset all position variables
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        // Remove only the inline styles that were added during dragging
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        // Restore centered class if it was removed
        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      // Listen for modal show event - reset when modal is about to show
      const handleShow = () => {
        // Reset immediately when modal starts showing
        resetPosition();
      };

      // Listen for modal shown event - ensure reset after modal is fully displayed
      const handleShown = () => {
        // Double-check reset after modal is fully shown
        resetPosition();
      };

      // Listen for modal hidden event - reset when modal is fully hidden
      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener("show.bs.modal", handleShow);
      modalElement.addEventListener("shown.bs.modal", handleShown);
      modalElement.addEventListener("hidden.bs.modal", handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove("modal-dialog-centered");

          // Set initial position based on current position
          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          // Preserve the modal's width and max-width to prevent size change
          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      // Event listeners
      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener("show.bs.modal", handleShow);
        modalElement.removeEventListener("shown.bs.modal", handleShown);
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        modalHeader.removeEventListener("mousedown", dragStart);
        document.removeEventListener("mousemove", drag);
        document.removeEventListener("mouseup", dragEnd);
      };
    };

    // Make all modals draggable
    const cleanup1 = makeModalDraggable("add_target");
    const cleanup2 = makeModalDraggable("edit_target");
    const cleanup3 = makeModalDraggable("delete_target");
    const cleanup4 = makeModalDraggable("calculate_incentive");

    return () => {
      cleanup1?.();
      cleanup2?.();
      cleanup3?.();
      cleanup4?.();
    };
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    if (!clientId) {
      setError("Client ID is missing");
      setLoading(false);
      return;
    }
    try {
      const [incentives, userData] = await Promise.all([
        getAllIncentives(),
        fetchUsersByClientId(clientId),
      ]);

      // Filter out IncentiveFallback and use only Incentive objects
      const validIncentives: Incentive[] = incentives.filter(
        (item): item is Incentive => typeof item.target === "number"
      );

      setDataSource(validIncentives);
      setOrderedData(validIncentives);
      setUsers(Array.isArray(userData) ? userData : []);
    } catch (err) {
      setError("Failed to load data.");
      setDataSource([]);
      setUsers([]);
    }
    setLoading(false);
  };

  const handleCreateTarget = async () => {
    // Clear previous errors
    setNewTargetError(null);
    setNewUserError(null);
    setNewPctError(null);

    // Salary validation
    const salaryCheck = validateSalary(newTarget);
    if (!salaryCheck.valid) {
      setNewTargetError(salaryCheck.message);
      return;
    }

    // User validation
    const userCheck = validateSelect(newUserId, "user");
    if (!userCheck.valid) {
      setNewUserError(userCheck.message);
      return;
    }

    // Incentive %
    const pctCheck = validateIncentivePercentage(newIncentivePercentage);
    if (!pctCheck.valid) {
      setNewPctError(pctCheck.message);
      return;
    }
    setSaving(true);

    try {
      await createTarget({
        user_id: newUserId,
        salary: newTarget,
        // incentive_percentage: newIncentivePercentage
      });

      toast.success("Target created successfully!");
      await loadData();

      // Reset fields
      setNewTarget(0);
      setNewUserId("");
      setNewIncentivePercentage(0);

      setIsAddModalOpen(false);
    } catch (err) {
      console.log(err);
      toast.error("Failed to create target");
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateTarget = async () => {
    // Clear errors
    setEditTargetError(null);
    setEditUserError(null);
    setEditPctError(null);

    if (!editTarget) return;

    // Salary validation
    const salaryCheck = validateSalary(editTargetValue);
    if (!salaryCheck.valid) {
      setEditTargetError(salaryCheck.message);
      return;
    }

    // User validation
    const userCheck = validateSelect(editUserId, "user");
    if (!userCheck.valid) {
      setEditUserError(userCheck.message);
      return;
    }

    // Incentive %
    const pctCheck = validateIncentivePercentage(editIncentivePercentage);
    if (!pctCheck.valid) {
      setEditPctError(pctCheck.message);
      return;
    }
    setSaving(true);
    try {
      await deleteTarget(editTarget.id.toString());

      await createTarget({
        user_id: editUserId,
        salary: editTargetValue,
        // incentive_percentage: editIncentivePercentage
      });

      await loadData();
      toast.success("Target updated successfully!");
      // reset edit fields
      setEditTarget(null);
      setEditTargetValue(0);
      setEditUserId("");
      setEditIncentivePercentage(0);

      setIsEditModalOpen(false);
    } catch (err) {
      console.log(err);
      toast.error("Failed to update target!");
    } finally {
      setSaving(false);
    }
  };

  const handleCalculateIncentive = async () => {
    const userCheck = validateSelect(calculateUserId, "user");
    setCalculating(true);
    if (!userCheck.valid) {
      toast.error(userCheck.message);
      return;
    }

    try {
      const result = await getIncentiveByUser(calculateUserId);
      setIncentiveResult(result);
      // ✅ Now open the result modal
      setShowResultModal(true);
    } catch (err) {
      // API error handling
    } finally {
      setCalculating(false);
    }
  };

  const handleConfirmDelete = async () => {
    if (!deleteTargetId) return;
    setDeleting(true);
    try {
      await deleteTarget(deleteTargetId.toString());
      toast.success("Target deleted successfully!");
      await loadData();
      setDeleteTargetId(null);
    } catch (err) {
      // Error handled in API
    } finally {
      setDeleting(false);
    }
  };
  // ADD TARGET FORM VALIDATION
  const isAddFormValid = (() => {
    const salaryCheck = validateSalary(newTarget);
    const userCheck = validateSelect(newUserId, "user");
    const pctCheck = validateIncentivePercentage(newIncentivePercentage);
    return salaryCheck.valid && userCheck.valid && pctCheck.valid;
  })();

  // EDIT TARGET FORM VALIDATION
  const isEditFormValid = (() => {
    if (!editTarget) return false;
    const salaryCheck = validateSalary(editTargetValue);
    const userCheck = validateSelect(editUserId, "user");
    const pctCheck = validateIncentivePercentage(editIncentivePercentage);
    return salaryCheck.valid && userCheck.valid && pctCheck.valid;
  })();

  const filteredData = useMemo(() => {
    const q = searchText.toLowerCase();

    const result = dataSource.filter((item) => {
      const userName = getUserName(item.user_id).toLowerCase();
      const salary = item.salary?.toString() || "";
      const target = item.target?.toString() || "";
      const incentive = item.incentive_percentage?.toString() || "";
      const created = item.created_at || "";

      // 🔍 Main search (text input)
      const matchesSearch =
        userName.includes(q) ||
        salary.includes(q) ||
        target.includes(q) ||
        incentive.includes(q) ||
        created.toLowerCase().includes(q);

      // 📅 Date range filter
      let matchesDate = true;
      if (selectedDateRange && created) {
        const createdDate = new Date(created);
        const [start, end] = selectedDateRange;
        matchesDate = createdDate >= start && createdDate <= end;
      }
      const alphaMatch =
        alphaFilter === "All" ||
        (item.user_name &&
          item.user_name.toLowerCase().startsWith(alphaFilter.toLowerCase()));

      // 🎯 Individual dropdown filters
      const matchesUserFilter =
        filterUsers.length === 0 ||
        filterUsers.includes(getUserName(item.user_id));
      const matchesSalaryFilter =
        filterSalaries.length === 0 || filterSalaries.includes(salary);
      const matchesTargetFilter =
        filterTargets.length === 0 || filterTargets.includes(target);
      const matchesIncentiveFilter =
        filterIncentives.length === 0 || filterIncentives.includes(incentive);

      const createdFormatted = item.created_at
        ? new Date(item.created_at).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        : "";
      const matchesCreatedFilter =
        filterCreatedAts.length === 0 ||
        filterCreatedAts.includes(createdFormatted);

      // ✅ Combine all filters
      return (
        matchesSearch &&
        matchesDate &&
        matchesUserFilter &&
        matchesSalaryFilter &&
        matchesTargetFilter &&
        matchesIncentiveFilter &&
        alphaMatch &&
        matchesCreatedFilter
      );
    });

    // 🔽 Sorting
    if (sortOption === "ascending") {
      result.sort((a, b) =>
        getUserName(a.user_id).localeCompare(getUserName(b.user_id))
      );
    } else if (sortOption === "descending") {
      result.sort((a, b) =>
        getUserName(b.user_id).localeCompare(getUserName(a.user_id))
      );
    } else if (sortOption === "recently_added") {
      result.sort(
        (a, b) =>
          new Date(b.created_at || "").getTime() -
          new Date(a.created_at || "").getTime()
      );
    }

    return result;
  }, [
    dataSource,
    users,
    searchText,
    sortOption,
    selectedDateRange,
    filterUsers,
    filterSalaries,
    filterTargets,
    filterIncentives,
    filterCreatedAts,
    alphaFilter,
  ]);

  const columns = [
    {
      title: "S.No",
      key: "SI_no",
      dataIndex: "SI_no",
      fixed: "left",
      render: (_text: any, _record: any, index: number) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: (
        <div
          className="flex items-center justify-between"
          style={{ height: 22, whiteSpace: "nowrap" }}
          onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
        >
          <span className="me-4">User Name</span>

          {/* Ant Design Dropdown – pure, tiny, beautiful */}
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu
                selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
                onClick={({ key }) =>
                  setAlphaFilter(key === "All" ? "All" : String(key))
                }
                style={{ width: 50, maxHeight: 250, overflow: "auto" }}
              >
                <Menu.Item key="All" className="text-center">
                  All
                </Menu.Item>
                {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                  <Menu.Item key={letter} className="text-center">
                    {letter}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <Button
              size="small"
              type="text"
              onClick={(e) => e.stopPropagation()}
              style={{
                fontSize: 12,
                height: 17,
                padding: "0 8px",
                border: "1px solid #d9d9d9",
                background: "#fafafa",
              }}
            >
              {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
              <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
            </Button>
          </Dropdown>
        </div>
      ),
      dataIndex: "user_name",
      key: "user_name",
      sorter: (a: Incentive, b: Incentive) =>
        a.user_name.localeCompare(b.user_name),
      render: (_: any, record: TargetDetail) => (
        <SubmoduleHoverCard2
          name={highlightMatch(record.user_name, searchTerm)}
          role="Target"
          contactleadowner_name={record.user_name}
          leadowner_name={record.user_name}
          dealowner_name={record.user_name}
          createdAt={record.created_at}
          variant2={["contactleadOwner", "leadOwner", "dealOwner"]}
        />

      ),
    },
    {
      title: "Salary",
      dataIndex: "salary",
      key: "salary",
      sorter: (a: Incentive, b: Incentive) => a.salary - b.salary,
      render: (text: number) =>
        highlightMatch(`₹${text.toLocaleString("en-IN")}`, searchTerm),
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
      sorter: (a: Incentive, b: Incentive) => a.target - b.target,
      render: (text: number) =>
        highlightMatch(`₹${text.toLocaleString("en-IN")}`, searchTerm),
    },
    {
      title: "Incentive Target",
      dataIndex: "incentive_target",
      key: "incentive_target",
      sorter: (a: Incentive, b: Incentive) =>
        a.incentive_target - b.incentive_target,
      render: (text: number) =>
        highlightMatch(`₹${text.toLocaleString("en-IN")}`, searchTerm),
    },
    {
      title: "Total Deal Value",
      dataIndex: "total_deal_value",
      key: "total_deal_value",
      sorter: (a: Incentive, b: Incentive) =>
        a.total_deal_value - b.total_deal_value,
      render: (text: number) =>
        highlightMatch(`₹${text.toLocaleString("en-IN")}`, searchTerm),
    },
    {
      title: "Incentive %",
      dataIndex: "incentive_percentage",
      key: "incentive_percentage",
      sorter: (a: Incentive, b: Incentive) =>
        a.incentive_percentage - b.incentive_percentage,
      render: (text: number) =>
        highlightMatch(`${text.toFixed(2)}%`, searchTerm),
    },
    {
      title: "Incentive Achieved Amount",
      dataIndex: "incentive_achieved_amount",
      key: "incentive_achieved_amount",
      sorter: (a: Incentive, b: Incentive) =>
        a.incentive_percentage - b.incentive_percentage,
      render: (text: number) =>
        highlightMatch(`${text.toFixed(2)}%`, searchTerm),
    },
    {
      title: "Calculated Incentive",
      dataIndex: "calculated_incentive",
      key: "calculated_incentive",
      sorter: (a: Incentive, b: Incentive) =>
        a.calculated_incentive - b.calculated_incentive,
      render: (text: number) =>
        highlightMatch(`₹${text.toLocaleString("en-IN")}`, searchTerm),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a: Incentive, b: Incentive) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: (text: string) => {
        const date = new Date(text);
        if (isNaN(date.getTime())) return "-";
        const dateStr = date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const timeStr = date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        return (
          <div>
            <div>{highlightMatch(dateStr, searchTerm)}</div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              {highlightMatch(timeStr, searchTerm)}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_: any, record: Incentive) => {
        const menu = (
          <Menu
            onClick={(e) => e.domEvent.stopPropagation()}
            style={{ minWidth: 160 }}
          >
            <Menu.Item
              key="edit"
              onClick={() => {
                setEditTarget(record);
                setEditTargetValue(record.salary);
                setEditUserId(record.user_id);
                setEditIncentivePercentage(record.incentive_percentage);
                setIsEditModalOpen(true);
              }}
            >
              <i className="ti ti-edit text-blue me-2" />
              Edit
            </Menu.Item>

            <Menu.Item
              key="delete"
              data-bs-toggle="modal"
              data-bs-target="#delete_target"
              onClick={() => setDeleteTargetId(record.id)}
            >
              <i className="ti ti-trash text-danger me-2" />
              Delete
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown
            trigger={["click"]}
            overlay={menu}
            placement="bottomRight"
            onOpenChange={(open) =>
              open && setTimeout(() => document.body.click(), 0)
            }
          >
            <Button
              size="small"
              type="text"
              className="table-action-btn"
              onClick={(e) => e.stopPropagation()}
            >
              <i className="fa fa-ellipsis-v" />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const handleRowOrderChange = (newOrdered: Incentive[]) => {
    setOrderedData(newOrdered);
    // OPTIONAL: persist to backend
    // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
  };

  const totalTargets = useMemo(() => dataSource.length, [dataSource]);

  const thisMonthTargets = useMemo(() => {
    const now = new Date();
    const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    return dataSource.filter((item) => {
      if (!item.created_at) return false;
      const date = new Date(item.created_at);
      return date >= thisMonthStart;
    }).length;
  }, [dataSource]);

  const prevMonthTargets = useMemo(() => {
    const now = new Date();
    const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const prevMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

    return dataSource.filter((item) => {
      if (!item.created_at) return false;
      const date = new Date(item.created_at);
      return date >= prevMonth && date <= prevMonthEnd;
    }).length;
  }, [dataSource]);

  const thisMonthPercentage = useMemo(() => {
    if (prevMonthTargets === 0) return thisMonthTargets > 0 ? "100" : "0";
    return (
      ((thisMonthTargets - prevMonthTargets) / prevMonthTargets) *
      100
    ).toFixed(1);
  }, [thisMonthTargets, prevMonthTargets]);

  const totalTargetAmount = useMemo(() => {
    return dataSource.reduce((sum, item) => sum + (item.target || 0), 0);
  }, [dataSource]);

  const totalAchievedAmount = useMemo(() => {
    return dataSource.reduce(
      (sum, item) => sum + (item.total_deal_value || 0),
      0
    );
  }, [dataSource]);

  const achievedPercentage = useMemo(() => {
    if (totalTargetAmount === 0) return "0";
    return ((totalAchievedAmount / totalTargetAmount) * 100).toFixed(1);
  }, [totalAchievedAmount, totalTargetAmount]);

  const totalIncentiveAmount = useMemo(() => {
    return dataSource.reduce(
      (sum, item) => sum + (item.calculated_incentive || 0),
      0
    );
  }, [dataSource]);

  const effectiveIncentivePercentage = useMemo(() => {
    const totalExcess = dataSource.reduce((sum, item) => {
      if ((item.total_deal_value || 0) > (item.target || 0)) {
        return sum + ((item.total_deal_value || 0) - (item.target || 0));
      }
      return sum;
    }, 0);
    if (totalExcess === 0) return "0";
    return ((totalIncentiveAmount / totalExcess) * 100).toFixed(1);
  }, [dataSource, totalIncentiveAmount]);

  const handleExportAllPDF = async () => {
    try {
      const blob = await exportTargetPDF();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `targets_all_${new Date().toISOString().split("T")[0]
        }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // toast handled in API
    }
  };

  const handleExportAllExcel = async () => {
    try {
      const blob = await exportTargetExcel();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `targets_all_${new Date().toISOString().split("T")[0]
        }.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // toast handled
    }
  };

  const handleExportSelectedPDF = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one target to export.");
      return;
    }
    try {
      const blob = await exportSelectedTargetPDF(selectedRows);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `targets_selected_${selectedRows.length}_${new Date().toISOString().split("T")[0]
        }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // handled in API
    }
  };

  const handleExportSelectedExcel = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one target to export.");
      return;
    }
    try {
      const blob = await exportSelectedTargetExcel(selectedRows);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `targets_selected_${selectedRows.length}_${new Date().toISOString().split("T")[0]
        }.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // handled in API
    }
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one target to delete.");
      return;
    }
    setDeleting(true);
    try {
      await deleteTargetBulk(selectedRows);
      toast.success(
        `${selectedRows.length} Target${selectedRows.length > 1 ? "s" : ""
        } deleted successfully`
      );
      await getAllIncentives(); // Adjust to your refresh function (e.g., getAllIncentives call)
      setSelectedRows([]);
      // const modalEl = document.getElementById("bulk_delete_modal");
      // if (modalEl) {
      //   const modal = Modal.getInstance(modalEl);
      //   modal?.hide();
      // }
    } catch (err) {
      // error toast already in API
    } finally {
      setDeleting(false);
    }
  };
  return (
    <>
      <PageLoadProgressBar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header mb-0">
                <div className="row align-items-center">
                  <div className="col-sm-8">
                    <h4 className="page-title">
                      <i className="bi bi-bullseye text-primary me-2" />
                      Targets{" "}
                      <span className="count-title ms-2">
                        <CountUp
                          end={dataSource.length}
                          duration={3.0}
                          separator=","
                        />
                      </span>
                    </h4>
                  </div>
                  <div className="col-sm-4 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumb */}
              <nav
                aria-label="breadcrumb"
                className="page-header-breadcrumb mb-3"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        userRole === "admin"
                          ? route.dealsDashboard
                          : route.leadsDashboard
                      }
                      style={{
                        color: "#9595b5",
                        textDecoration: "none",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "#E41F07")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#9595b5")
                      }
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Target
                  </li>
                </ol>
              </nav>
              {/* /Breadcrumb */}
              <div className="row g-3 mb-4">
                {(() => {
                  const total = totalTargets;
                  const thisMonthPercent =
                    total > 0
                      ? ((thisMonthTargets / total) * 100).toFixed(1)
                      : 0;
                  const achievedPercent = achievedPercentage;
                  const effectivePercent = effectiveIncentivePercentage;

                  return (
                    <>
                      {/* Total Targets */}
                      <div className="col-12 col-sm-6 col-lg-3">
                        <Tip
                          text={`Total Targets: ${totalTargets} (100%)`}
                          placement="top"
                        >
                          <div className="kpi-card-wrapper">
                            <KpiCard
                              title="Targets"
                              subtitle="Total"
                              value={totalTargets}
                              icon="ti ti-trophy"
                              color="primary"
                              tooltip="Total number of targets"
                            />
                          </div>
                        </Tip>
                      </div>

                      {/* This Month Targets */}
                      <div className="col-12 col-sm-6 col-lg-3">
                        <Tip
                          text={`Targets This Month: ${thisMonthTargets} (${thisMonthPercent}%)`}
                          placement="top"
                        >
                          <div className="kpi-card-wrapper">
                            <KpiCard
                              title="Targets"
                              subtitle="This Month"
                              value={thisMonthTargets}
                              icon="ti ti-calendar"
                              color="warning"
                              tooltip="Targets created this month"
                              percentage={thisMonthPercentage}
                              percentageColor={
                                parseFloat(thisMonthPercentage) > 0
                                  ? "success"
                                  : "danger"
                              }
                              percentageIcon={
                                parseFloat(thisMonthPercentage) > 0
                                  ? "ti ti-arrow-up"
                                  : "ti ti-arrow-down"
                              }
                            />
                          </div>
                        </Tip>
                      </div>

                      {/* Total Target Amount */}
                      <div className="col-12 col-sm-6 col-lg-3">
                        <Tip
                          text={`Total Target Amount: ₹${totalTargetAmount.toLocaleString(
                            "en-IN"
                          )} (Achieved ${achievedPercent}%)`}
                          placement="top"
                        >
                          <div className="kpi-card-wrapper">
                            <KpiCard
                              title="Target Amount"
                              subtitle="Total"
                              value={totalTargetAmount}
                              icon="ti ti-currency-rupee"
                              color="success"
                              tooltip="Total target amount"
                              percentage={achievedPercentage}
                              percentageColor={
                                parseFloat(achievedPercentage) >= 100
                                  ? "success"
                                  : "danger"
                              }
                              percentageIcon={
                                parseFloat(achievedPercentage) >= 100
                                  ? "ti ti-arrow-up"
                                  : "ti ti-arrow-down"
                              }
                            />
                          </div>
                        </Tip>
                      </div>

                      {/* Total Calculated Incentive */}
                      <div className="col-12 col-sm-6 col-lg-3">
                        <Tip
                          text={`Total Calculated Incentive: ₹${totalIncentiveAmount.toLocaleString(
                            "en-IN"
                          )} (Effective Rate ${effectivePercent}%)`}
                          placement="top"
                        >
                          <div className="kpi-card-wrapper">
                            <KpiCard
                              title="Incentive"
                              subtitle="Calculated"
                              value={totalIncentiveAmount}
                              icon="ti ti-trending-up"
                              color="info"
                              tooltip="Total calculated incentive"
                              percentage={effectiveIncentivePercentage}
                              percentageColor="info"
                              percentageIcon="ti ti-arrow-up"
                            />
                          </div>
                        </Tip>
                      </div>
                    </>
                  );
                })()}
              </div>
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-start">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0 position-relative ms-3">
                        <span className="form-icon">
                          <i className="ti ti-search text-muted fs-16" />
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-lg ps-5 rounded-3 border shadow-sm"
                          placeholder="Search Target..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{ height: "42px", fontSize: "14px" }}
                        />

                        {/* Clear button appears when there's text */}
                        {searchText && (
                          <button
                            type="button"
                            className="btn-close position-absolute end-0 top-50 translate-middle-y me-3"
                            style={{ zIndex: 10, fontSize: "12px" }}
                            onClick={() => setSearchText("")}
                            aria-label="Clear search"
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        {/* <button
    type="button"
    className="btn btn-outline-success d-flex align-items-center gap-2 me-2"
    data-bs-toggle="modal"
    aria-label="Import targets from Excel"
    data-bs-target="#import_excel_modal"
  >
    <i className="ti ti-file-import fs-16" />
    <span className="d-none d-sm-inline">Import Excel</span>
  </button> */}

                        <div className="dropdown me-3">
                          <button
                            type="button"
                            className={`btn btn-outline-secondary d-flex align-items-center gap-2 dropdown-toggle ${selectedRows.length > 0
                              ? "border-primary text-primary"
                              : ""
                              }`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={loading}
                          >
                            <i className="ti ti-package-export fs-16" />
                            <span className="d-none d-sm-inline">Export</span>
                            {selectedRows.length > 0 && (
                              <span className="badge bg-primary rounded-pill ms-2">
                                {selectedRows.length}
                              </span>
                            )}
                          </button>

                          <ul
                            className="dropdown-menu dropdown-menu-end shadow-lg border-0 py-3 px-2"
                            style={{ minWidth: "260px" }}
                          >
                            <li>
                              <div className="px-3 mb-2">
                                <small className="text-uppercase text-muted fw-bold">
                                  Export Options
                                </small>
                              </div>
                            </li>
                            <li>
                              <hr className="dropdown-divider my-1" />
                            </li>
                            <li>
                              <div className="px-3 py-1">
                                <small className="text-muted">
                                  All Records ({filteredData.length})
                                </small>
                              </div>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllPDF}
                              >
                                <div className="avatar avatar-sm bg-danger-light rounded">
                                  <i className="ti ti-file-type-pdf text-danger fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">Export as PDF</div>
                                  <small className="text-muted">
                                    Portable Document Format
                                  </small>
                                </div>
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllExcel}
                              >
                                <div className="avatar avatar-sm bg-success-light rounded">
                                  <i className="ti ti-file-spreadsheet text-success fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">
                                    Export as Excel
                                  </div>
                                  <small className="text-muted">
                                    Spreadsheet (.xlsx)
                                  </small>
                                </div>
                              </button>
                            </li>

                            {selectedRows.length > 0 && (
                              <>
                                <li>
                                  <hr className="dropdown-divider my-2" />
                                </li>
                                <li>
                                  <div className="px-3 py-1">
                                    <small className="text-muted">
                                      Selected Only ({selectedRows.length})
                                    </small>
                                  </div>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={handleExportSelectedPDF}
                                  >
                                    <div className="avatar avatar-sm bg-danger-light rounded">
                                      <i className="ti ti-file-type-pdf text-danger fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">
                                        Export Selected as PDF
                                      </div>
                                    </div>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={handleExportSelectedExcel}
                                  >
                                    <div className="avatar avatar-sm bg-success-light rounded">
                                      <i className="ti ti-file-spreadsheet text-success fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">
                                        Export Selected as Excel
                                      </div>
                                    </div>
                                  </button>
                                </li>
                              </>
                            )}

                            {selectedRows.length === 0 && (
                              <li>
                                <div className="text-center py-4 px-3">
                                  <i className="ti ti-checkbox fs-32 text-muted d-block mb-2" />
                                  <small className="text-muted">
                                    Select rows to export specific records
                                  </small>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>

                        <Link
                          to="#"
                          className="btn btn-primary me-2"
                          onClick={() => {
                            // Reset form fields and errors when opening modal
                            setNewTarget(0);
                            setNewUserId("");
                            setNewIncentivePercentage(0);
                            setNewTargetError(null);
                            setNewUserError(null);
                            setNewPctError(null);

                            // Open modal using React state
                            setIsAddModalOpen(true);
                          }}
                          style={{
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <i
                            className="ti ti-square-rounded-plus me-2"
                            style={{ position: "relative", zIndex: 2 }}
                          />
                          <span style={{ position: "relative", zIndex: 2 }}>
                            Add New Target
                          </span>
                          <span
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background:
                                "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                              transform: "skewX(-20deg) translateX(-150%)",
                              animation: "shine 3s infinite",
                            }}
                          />
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary me-3"
                          data-bs-toggle="modal"
                          data-bs-target="#calculate_incentive"
                          style={{
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <i
                            className="ti ti-calculator me-2"
                            style={{ position: "relative", zIndex: 2 }}
                          />
                          <span style={{ position: "relative", zIndex: 2 }}>
                            Calculate Incentive
                          </span>
                          <span
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background:
                                "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                              transform: "skewX(-20deg) translateX(-150%)",
                              animation: "shine 3s infinite",
                            }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap row-gap-2">
                  <div className="d-flex align-items-center flex-wrap row-gap-2">
                    <div className="dropdown me-2">
                      <Link
                        to="#"
                        className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >

                        <i className="ti ti-sort-ascending-2 me-2" />
                        Sort
                      </Link>
                      <div className="dropdown-menu dropdown-menu-start">
                        <ul className="list-unstyled mb-0">
                          {[
                            { label: "Ascending", value: "ascending" },
                            { label: "Descending", value: "descending" },
                            {
                              label: "Recently Added",
                              value: "recently_added",
                            },
                          ].map(({ label, value }) => {
                            const isActive = sortOption === value;
                            return (
                              <li key={value}>
                                <Link
                                  to="#"
                                  className={`dropdown-item d-flex justify-content-between align-items-center ${isActive ? "fw-bold text-primary" : ""
                                    }`}
                                  onClick={() => setSortOption(value)}
                                >
                                  <span>
                                    <i className="ti ti-circle-chevron-right me-1" />
                                    {label}
                                  </span>
                                  {isActive && <i className="ti ti-check" />}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>

                    {/* Date Range Picker */}
                    <div className="icon-form">
                      <span className="form-icon">
                        <i className="ti ti-calendar" />
                      </span>
                      <DateRangePicker
                        initialSettings={initialSettings}
                        onCallback={(start, end, label) => {
                          setSelectedDateRange([start.toDate(), end.toDate()]);
                          if (label) setActiveRangeLabel(label);
                        }}
                      >
                        <input
                          className="form-control bookingrange"
                          type="text"
                          readOnly
                          style={{ minWidth: "200px" }}
                        />
                      </DateRangePicker>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap ms-2">
                    {selectedRows.length > 0 && (
                      <button
                        type="button"
                        className={`btn btn-outline-danger d-flex align-items-center gap-2 ${selectedRows.length === 0
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        data-bs-toggle="modal"
                        data-bs-target="#bulk_delete_modal"
                        disabled={selectedRows.length === 0}
                      >
                        <i className="ti ti-trash fs-16" />
                        <span className="d-none d-sm-inline">
                          Delete Selected
                        </span>
                        {selectedRows.length > 0 && (
                          <span className="badge bg-danger rounded-pill ms-2">
                            {selectedRows.length}
                          </span>
                        )}
                      </button>
                    )}
                    {/* View Toggle */}
                    <div className="d-flex align-items-center ms-2 p-1 border bg-white rounded" style={{ height: "35px" }}>
                      <button
                        className={`btn btn-icon btn-sm view-mode-btn rounded ${viewMode === 'list' ? 'active' : 'text-muted'}`}
                        onClick={() => setViewMode('list')}
                        title="List View"
                        style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <i className="ti ti-list-details" />
                      </button>
                      <button
                        className={`btn btn-icon btn-sm view-mode-btn rounded ms-1 ${viewMode === 'grid' ? 'active' : 'text-muted'}`}
                        onClick={() => setViewMode('grid')}
                        title="Grid View"
                        style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center" }}
                      >

                        <i className="ti ti-layout-grid" />
                      </button>
                    </div>
                    {viewMode === 'list' && (
                      <div className="dropdown me-2 ms-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-end dropdown-md p-3"
                          style={{ minWidth: "250px" }}
                        >
                          <h4 className="mb-2 fw-semibold">Manage Columns</h4>
                          <p className="mb-3">
                            Drag and drop columns to reorder and toggle
                            visibility.
                          </p>
                          <div className="border-top pt-3">
                            <ColumnManagement
                              columnKeys={columnKeys}
                              visibleColumns={visibleColumns}
                              onColumnOrderChange={setColumnKeys}
                              onColumnToggle={handleColumnToggle}
                              fixedKeys={["action"]}
                              labels={{ SI_no: "S.No" }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {/* 🔍 Filter Dropdown UI */}
                    <div className="form-sorts dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle dropdown-active-toggle common-filter-btn d-flex align-items-center gap-2 fw-medium"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="outside"
                      >

                        <i className="ti ti-filter-share" /> Filter
                        {(filterUsers.length > 0 ||
                          filterSalaries.length > 0 ||
                          filterTargets.length > 0 ||
                          filterIncentives.length > 0 ||
                          filterCreatedAts.length > 0) && (
                            <span className="badge filter-btn-badge rounded-pill ms-2">
                              {filterUsers.length +
                                filterSalaries.length +
                                filterTargets.length +
                                filterIncentives.length +
                                filterCreatedAts.length}
                            </span>
                          )}
                      </Link>

                      <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                        <div className="filter-set-view">
                          <div className="filter-set-head">
                            <h4>
                              <i className="ti ti-filter-share" /> Filter
                            </h4>
                          </div>

                          <div className="accordion" id="accordionExample">
                            {/* User Name Filter */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "user" ? "" : "collapsed"
                                  }
                                  onClick={() => handleAccordionToggle("user")}
                                >
                                  User Name
                                </Link>
                                {filterUsers.length > 0 && (
                                  <span className="badge bg-primary rounded-pill small">
                                    {filterUsers.length}
                                  </span>
                                )}
                              </div>
                              {openAccordion === "user" && (
                                <div className="filter-set-contents accordion-collapse collapse show">
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search User"
                                        value={filterUserSearch}
                                        onChange={(e) =>
                                          setFilterUserSearch(e.target.value)
                                        }
                                      />
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                      {uniqueUsers
                                        .filter((u) =>
                                          u
                                            .toLowerCase()
                                            .includes(
                                              filterUserSearch.toLowerCase()
                                            )
                                        )
                                        .map((user) => (
                                          <li key={user}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterUsers.includes(
                                                    user
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      user,
                                                      filterUsers,
                                                      setFilterUsers
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {user}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueUsers.filter((u) =>
                                        u
                                          .toLowerCase()
                                          .includes(
                                            filterUserSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>

                            <hr className="my-2" />

                            {/* Salary Filter */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "salary"
                                      ? ""
                                      : "collapsed"
                                  }
                                  onClick={() =>
                                    handleAccordionToggle("salary")
                                  }
                                >
                                  Salary
                                </Link>
                                {filterSalaries.length > 0 && (
                                  <span className="badge bg-primary rounded-pill small">
                                    {filterSalaries.length}
                                  </span>
                                )}
                              </div>
                              {openAccordion === "salary" && (
                                <div className="filter-set-contents accordion-collapse collapse show">
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Salary"
                                        value={filterSalarySearch}
                                        onChange={(e) =>
                                          setFilterSalarySearch(e.target.value)
                                        }
                                      />
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                      {uniqueSalaries
                                        .filter((s) =>
                                          s
                                            .toLowerCase()
                                            .includes(
                                              filterSalarySearch.toLowerCase()
                                            )
                                        )
                                        .map((salary) => (
                                          <li key={salary}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterSalaries.includes(
                                                    salary
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      salary,
                                                      filterSalaries,
                                                      setFilterSalaries
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                ₹{salary}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueSalaries.filter((s) =>
                                        s
                                          .toLowerCase()
                                          .includes(
                                            filterSalarySearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>

                            <hr className="my-2" />

                            {/* Target Filter */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "target"
                                      ? ""
                                      : "collapsed"
                                  }
                                  onClick={() =>
                                    handleAccordionToggle("target")
                                  }
                                >
                                  Target
                                </Link>
                                {filterTargets.length > 0 && (
                                  <span className="badge bg-primary rounded-pill small">
                                    {filterTargets.length}
                                  </span>
                                )}
                              </div>
                              {openAccordion === "target" && (
                                <div className="filter-set-contents accordion-collapse collapse show">
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Target"
                                        value={filterTargetSearch}
                                        onChange={(e) =>
                                          setFilterTargetSearch(e.target.value)
                                        }
                                      />
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                      {uniqueTargets
                                        .filter((t) =>
                                          t
                                            .toLowerCase()
                                            .includes(
                                              filterTargetSearch.toLowerCase()
                                            )
                                        )
                                        .map((target) => (
                                          <li key={target}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterTargets.includes(
                                                    target
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      target,
                                                      filterTargets,
                                                      setFilterTargets
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                ₹{target}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueTargets.filter((t) =>
                                        t
                                          .toLowerCase()
                                          .includes(
                                            filterTargetSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>

                            <hr className="my-2" />

                            {/* Incentive % Filter */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "incentive"
                                      ? ""
                                      : "collapsed"
                                  }
                                  onClick={() =>
                                    handleAccordionToggle("incentive")
                                  }
                                >
                                  Incentive %
                                </Link>
                                {filterIncentives.length > 0 && (
                                  <span className="badge bg-primary rounded-pill small">
                                    {filterIncentives.length}
                                  </span>
                                )}
                              </div>
                              {openAccordion === "incentive" && (
                                <div className="filter-set-contents accordion-collapse collapse show">
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Incentive %"
                                        value={filterIncentiveSearch}
                                        onChange={(e) =>
                                          setFilterIncentiveSearch(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                      {uniqueIncentives
                                        .filter((i) =>
                                          i
                                            .toLowerCase()
                                            .includes(
                                              filterIncentiveSearch.toLowerCase()
                                            )
                                        )
                                        .map((incentive) => (
                                          <li key={incentive}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterIncentives.includes(
                                                    incentive
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      incentive,
                                                      filterIncentives,
                                                      setFilterIncentives
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {incentive}%
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueIncentives.filter((i) =>
                                        i
                                          .toLowerCase()
                                          .includes(
                                            filterIncentiveSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>

                            <hr className="my-2" />

                            {/* Created At Filter */}
                            <div className="filter-set-content">
                              <div className="filter-set-content-head d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className={
                                    openAccordion === "createdAt"
                                      ? ""
                                      : "collapsed"
                                  }
                                  onClick={() =>
                                    handleAccordionToggle("createdAt")
                                  }
                                >
                                  Created At
                                </Link>
                                {filterCreatedAts.length > 0 && (
                                  <span className="badge bg-primary rounded-pill small">
                                    {filterCreatedAts.length}
                                  </span>
                                )}
                              </div>
                              {openAccordion === "createdAt" && (
                                <div className="filter-set-contents accordion-collapse collapse show">
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Created At"
                                        value={filterDateSearch}
                                        onChange={(e) =>
                                          setFilterDateSearch(e.target.value)
                                        }
                                      />
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                      {uniqueCreatedAts
                                        .filter((d) =>
                                          d
                                            .toLowerCase()
                                            .includes(
                                              filterDateSearch.toLowerCase()
                                            )
                                        )
                                        .map((date) => (
                                          <li key={date}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterCreatedAts.includes(
                                                    date
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      date,
                                                      filterCreatedAts,
                                                      setFilterCreatedAts
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {date}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueCreatedAts.filter((d) =>
                                        d
                                          .toLowerCase()
                                          .includes(
                                            filterDateSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                          <p className="text-muted px-2">
                                            No data found
                                          </p>
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Reset / Apply Buttons */}
                          <div className="filter-reset-btns mt-3">
                            <div className="row">
                              <div className="col-6">
                                <Link
                                  to="#"
                                  className="btn btn-light w-100"
                                  onClick={resetFilters}
                                >
                                  Reset
                                </Link>
                              </div>
                              <div className="col-6">
                                <Link
                                  to="#"
                                  className="btn btn-primary w-100"
                                  data-bs-dismiss="dropdown"
                                >
                                  Apply
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 🔹 ACTIVE FILTER TITLES – MUST BE ABOVE TABLE */}
                {(filterUsers.length > 0 ||
                  filterCreatedAts.length > 0 ||
                  filterSalaries.length > 0 || // ← ADD
                  filterTargets.length > 0 || // ← ADD
                  filterIncentives.length > 0 || // ← ADD
                  alphaFilter !== "All" ||
                  selectedDateRange ||
                  searchText.length > 0 ||
                  sortOption !== "recently_added") && (
                    <div className="active-filters d-flex flex-wrap gap-2 mb-4 align-items-center-3">
                      {/* Search */}
                      {searchText.length > 0 && (
                        <div className="alert alert-primary py-2 mb-0">
                          <strong>Search:</strong> {searchText}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setSearchText("")}
                          />
                        </div>
                      )}

                      {/* Sort */}
                      {sortOption !== "recently_added" && (
                        <div className="alert alert-secondary py-2 mb-0">
                          <strong>Sort:</strong>{" "}
                          {sortOption
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setSortOption("recently_added")}
                          />
                        </div>
                      )}

                      {/* User Name */}
                      {filterUsers.length > 0 && (
                        <div className="alert alert-primary py-2 mb-0">
                          <strong>User Name:</strong> {filterUsers.join(", ")}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterUsers([])}
                          />
                        </div>
                      )}

                      {/* Salary */}
                      {filterSalaries.length > 0 && (
                        <div className="alert alert-info py-2 mb-0">
                          <strong>Salary:</strong> ₹{filterSalaries.join(", ₹")}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterSalaries([])}
                          />
                        </div>
                      )}

                      {/* Target */}
                      {filterTargets.length > 0 && (
                        <div className="alert alert-warning py-2 mb-0">
                          <strong>Target:</strong> ₹{filterTargets.join(", ₹")}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterTargets([])}
                          />
                        </div>
                      )}

                      {/* Incentive % */}
                      {filterIncentives.length > 0 && (
                        <div className="alert alert-success py-2 mb-0">
                          <strong>Incentive %:</strong>{" "}
                          {filterIncentives.join("%, ")}%
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterIncentives([])}
                          />
                        </div>
                      )}

                      {/* Created At */}
                      {filterCreatedAts.length > 0 && (
                        <div className="alert alert-secondary py-2 mb-0">
                          <strong>Created At:</strong>{" "}
                          {filterCreatedAts.join(", ")}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterCreatedAts([])}
                          />
                        </div>
                      )}

                      {/* Alphabetical Filter */}
                      {alphaFilter !== "All" && (
                        <div className="alert alert-success py-2 mb-0">
                          <strong>Title starts with:</strong> {alphaFilter}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setAlphaFilter("All")}
                          />
                        </div>
                      )}

                      {/* Date Range */}
                      {selectedDateRange && (
                        <div className="alert alert-dark py-2 mb-0">
                          <strong>Date:</strong>{" "}
                          {selectedDateRange[0].toLocaleDateString()} –{" "}
                          {selectedDateRange[1].toLocaleDateString()}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setSelectedDateRange(null)}
                          />
                        </div>
                      )}
                    </div>
                  )}

              
                  <div className="table-responsive custom-table">
                    {error ? (
                      <div className="text-center text-danger my-4">
                        {error}
                      </div>
                    ) : viewMode === "grid" ? (
                      <div className="p-3">
                        <style>
                          {`
                            .hover-actions {
                              opacity: 0;
                              transition: opacity 0.2s ease-in-out;
                            }
                            .grid-card:hover .hover-actions {
                              opacity: 1;
                            }
                            .grid-card:hover {
                              transform: translateY(-5px);
                              box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important;
                            }
                            .grid-avatar {
                              background: linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%);
                              color: white;
                              box-shadow: 0 4px 10px rgba(255, 107, 107, 0.3);
                            }
                          `}
                        </style>
                        <GridView
                          data={filteredData.slice(
                            (currentPage - 1) * pageSize,
                            currentPage * pageSize
                          )}
                          renderCard={(record: any) => (
                            <div className="col-xxl-3 col-xl-4 col-md-6 mb-4">
                              <div
                                className="card h-100 border-0 shadow-sm transition-all grid-card position-relative overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                <div className="card-body p-4 d-flex flex-column">
                                  {/* Header */}
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div
                                      className="avatar avatar-lg rounded-circle grid-avatar fw-bold d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        fontSize: "1.4rem",
                                        background:
                                          "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)",
                                        color: "white",
                                        boxShadow:
                                          "0 4px 10px rgba(255, 107, 107, 0.3)",
                                      }}
                                    >
                                      {getUserName(record.user_id)
                                        ?.charAt(0)
                                        .toUpperCase()}
                                    </div>
                                    <div className="d-flex gap-2 hover-actions">
                                      <button
                                        className="btn btn-sm btn-icon btn-light text-primary shadow-sm rounded-circle"
                                        onClick={() => {
                                          setEditTarget(record);
                                          setEditTargetValue(record.salary);
                                          setEditUserId(record.user_id);
                                          setEditIncentivePercentage(
                                            record.incentive_percentage || 0
                                          );
                                          setIsEditModalOpen(true);
                                        }}
                                        title="Edit"
                                        style={{ width: "32px", height: "32px" }}
                                      >
                                        <i className="ti ti-edit fs-14" />
                                      </button>
                                      <button
                                        className="btn btn-sm btn-icon btn-light text-danger shadow-sm rounded-circle"
                                        onClick={() =>
                                          setDeleteTargetId(record.id)
                                        }
                                        data-bs-toggle="modal"
                                        data-bs-target="#delete_target"
                                        title="Delete"
                                        style={{ width: "32px", height: "32px" }}
                                      >
                                        <i className="ti ti-trash fs-14" />
                                      </button>
                                    </div>
                                  </div>

                                  {/* Content */}
                                  <h5
                                    className="fw-bold text-dark mb-2 text-truncate"
                                    title={getUserName(record.user_id)}
                                  >
                                    {getUserName(record.user_id)}
                                  </h5>

                                  <div className="mb-3 d-flex flex-column gap-1">
                                    <div className="d-flex justify-content-between">
                                      <span className="text-muted small">
                                        Salary:
                                      </span>
                                      <span className="fw-semibold text-dark">
                                        ₹{record.salary?.toLocaleString()}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <span className="text-muted small">
                                        Target:
                                      </span>
                                      <span className="fw-semibold text-primary">
                                        ₹{record.target?.toLocaleString()}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <span className="text-muted small">
                                        Incentive:
                                      </span>
                                      <span className="badge bg-soft-success text-success">
                                        {record.incentive_percentage}%
                                      </span>
                                    </div>
                                  </div>

                                  {/* Footer */}
                                  <div className="mt-auto pt-3 border-top d-flex align-items-center justify-content-between text-muted small">
                                    <div className="d-flex align-items-center">
                                      <i className="ti ti-calendar me-1" />
                                      Created:
                                    </div>
                                    <div className="fw-medium">
                                      {record.created_at
                                        ? new Date(
                                          record.created_at
                                        ).toLocaleDateString()
                                        : "N/A"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        />
                        {/* Grid View Pagination */}
                        <div className="d-flex justify-content-end mt-4">
                          <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={filteredData.length}
                            onChange={(page: number, size: number) => {
                              setCurrentPage(page);
                              setPageSize(size);
                            }}
                            showSizeChanger
                            pageSizeOptions={["10", "20", "50", "75", "100"]}
                          />
                        </div>
                      </div>
                    ) : (
                      <Table
                        columns={columns
                          .sort(
                            (a, b) =>
                              columnKeys.indexOf(a.key as string) -
                              columnKeys.indexOf(b.key as string)
                          )
                          .filter(
                            (col) =>
                              visibleColumns[
                              col.key as keyof typeof visibleColumns
                              ]
                          )}
                        dataSource={filteredData}
                        rowKey="user_id"
                        loading={loading}
                        enableRowSelection={true}
                        className="custom-table"
                        emptyText="No Target found"
                        emptyIcon="ti ti-target-off"
                        recordLabel="Target"
                        rowSelection={{
                          selectedRowKeys: selectedRows,
                          onChange: (selectedRowKeys: React.Key[]) => {
                            setSelectedRows(selectedRowKeys as string[]);
                          },
                        }}
                        pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "75", "100"],
                          onChange: (page: number, size: number) => {
                            setCurrentPage(page);
                            setPageSize(size);
                          },
                        }}
                        draggable={true}
                        enableColumnDrag={true}
                        onColumnOrderChange={(newCols: any[]) => {
                          // Get the new order of non-sticky columns from the dragged columns
                          const newOrderedKeys = newCols
                            .filter((c) => !c.fixed) // Only non-sticky columns
                            .map((c) => c.key || c.dataIndex)
                            .filter(
                              (key) =>
                                key !== undefined && key !== null && key !== ""
                            ); // Remove invalid keys

                          // Preserve columns that are not in newCols (hidden columns) by merging with existing columnKeys
                          const existingKeys = columnKeys;
                          const allNonStickyKeys = defaultColumnOrder; // All possible non-sticky column keys

                          // Create a new array that:
                          // 1. Uses the new order for visible columns
                          // 2. Preserves the order of hidden columns that aren't in newCols
                          const preservedKeys = existingKeys.filter(
                            (key) => !newOrderedKeys.includes(key)
                          );
                          const finalKeys = [
                            ...newOrderedKeys,
                            ...preservedKeys,
                          ];

                          // Ensure all default columns are included (in case some are missing)
                          const missingKeys = allNonStickyKeys.filter(
                            (key) => !finalKeys.includes(key)
                          );
                          const completeKeys = [...finalKeys, ...missingKeys];

                          setColumnKeys(completeKeys);
                          // Don't auto-save, let user decide on navigation/refresh
                        }}
                        onRowOrderChange={handleRowOrderChange}
                        scroll={{ x: "max-content" }}
                        components={{
                          header: {
                            cell: (props: any) => (
                              <th
                                {...props}
                                style={{
                                  ...props.style,
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                  background: "#fff",
                                  boxShadow: "inset 0 -1px 0 #CBD5E1",
                                }}
                              />
                            ),
                          },
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add New Target Modal */}
        <div
          className={`modal fade effect-modal-show ${isAddModalOpen ? "show d-block" : ""}`}
          id="add_target"
          tabIndex={-1}
          style={{
            display: isAddModalOpen ? "block" : "none",
            backgroundColor: isAddModalOpen ? "rgba(0,0,0,0.5)" : "transparent",
          }}
          onClick={() => setIsAddModalOpen(false)} // Backdrop close
        >
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-primary fw-bold fw-semibold">
                  <i className="ti ti-square-rounded-plus-filled me-2 fs-20" />
                  Add New Target
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  onClick={() => setIsAddModalOpen(false)}
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                {/* Target Salary */}
                <div className="mb-3">
                  <label className="col-form-label fw-semibold">
                    Target Salary <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control form-control-lg ${newTargetError ? "is-invalid border-danger" : ""
                      }`}
                    value={newTarget || ""}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setNewTarget(val);
                      const res = validateSalary(val);
                      if (!/^[0-9]*$/.test(val.toString())) {
                        setNewTargetError("Salary must be a valid number.");
                        return;
                      }
                      setNewTargetError(res.valid ? null : res.message);
                    }}
                    placeholder="Enter target salary"
                    min="0"
                  />
                  {newTargetError && (
                    <div className="invalid-feedback">{newTargetError}</div>
                  )}
                </div>

                {/* User */}
                <div className="mb-3">
                  <label className="col-form-label fw-semibold">
                    User <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-control form-control-lg ${newUserError ? "is-invalid border-danger" : ""
                      }`}
                    value={newUserId}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewUserId(val);
                      const res = validateSelect(val, "user");
                      setNewUserError(res.valid ? null : res.message);
                    }}
                  >
                    <option value="" disabled>
                      Select User
                    </option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                  {newUserError && (
                    <div className="invalid-feedback">{newUserError}</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateTarget}
                  disabled={
                    saving ||
                    !!newTargetError ||
                    !!newUserError ||
                    !!newPctError
                  }
                >
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-check me-2" />
                      Create Target
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Target */}
        <div
          className={`modal fade effect-modal-show ${isEditModalOpen ? "show d-block" : ""}`}
          id="edit_target"
          tabIndex={-1}
          style={{
            display: isEditModalOpen ? "block" : "none",
            backgroundColor: isEditModalOpen ? "rgba(0,0,0,0.5)" : "transparent",
          }}
          onClick={() => setIsEditModalOpen(false)}
        >
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-primary fw-bold fw-semibold">
                  <i className="ti ti-edit me-2 fs-20" />
                  Edit Target
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  onClick={() => setIsEditModalOpen(false)}
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="col-form-label fw-semibold">
                    Target Salary <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control form-control-lg ${editTargetError ? "is-invalid border-danger" : ""
                      }`}
                    value={editTargetValue || ""}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setEditTargetValue(val);
                      const res = validateSalary(val);
                      // invalid number → block and show error
                      if (!/^[0-9]*$/.test(val.toString())) {
                        setEditTargetError("Salary must be a valid number.");
                        return;
                      }
                      setEditTargetError(res.valid ? null : res.message);
                    }}
                    min="0"
                  />
                  {editTargetError && (
                    <div className="invalid-feedback">{editTargetError}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="col-form-label fw-semibold">
                    User <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-control form-control-lg ${editUserError ? "is-invalid border-danger" : ""
                      }`}
                    value={editUserId}
                    onChange={(e) => {
                      const val = e.target.value;
                      setEditUserId(val);
                      const res = validateSelect(val, "user");
                      setEditUserError(res.valid ? null : res.message);
                    }}
                  >
                    <option value="" disabled>
                      Select User
                    </option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                  {editUserError && (
                    <div className="invalid-feedback">{editUserError}</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpdateTarget}
                  disabled={saving || !!editTargetError || !!editUserError}
                >
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-check me-2" />
                      Save Changes
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Calculate Incentive */}
        <div className="modal fade" id="calculate_incentive">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-primary fw-bold fw-semibold">
                  <i className="ti ti-calculator me-2 fs-20" />
                  Calculate User Incentive
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="col-form-label fw-semibold">
                    Select User <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-control form-control-lg ${calculateUserError.calculateUserId
                      ? "is-invalid border-danger"
                      : ""
                      }`}
                    value={calculateUserId}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCalculateUserId(value);
                      const errors = validateUserSelect({
                        calculateUserId: value,
                      });
                      setCalculateUserError(errors);
                    }}
                  >
                    <option value="" disabled>
                      Select User
                    </option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                  {calculateUserError.calculateUserId && (
                    <div className="invalid-feedback fw-medium mt-2">
                      {calculateUserError.calculateUserId}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!calculateUserId || calculating}
                  onClick={handleCalculateIncentive}
                >
                  {calculating ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Calculating...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-calculator me-2" />
                      Calculate Incentive
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {showResultModal && (
          <div
            className="modal fade show d-block"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "12px" }}
              >
                <div className="modal-header bg-primary text-white border-0 rounded-top">
                  <h5 className="modal-title fw-bold">
                    <i className="ti ti-wallet me-2 fs-20" />
                    User Incentive Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => {
                      setShowResultModal(false);
                      setCalculateUserId("");
                      setIncentiveResult(null);
                    }}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body p-4 bg-light">
                  {incentiveResult ? (
                    <div className="row g-4">
                      {/* User Info Card */}
                      <div className="col-12">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <h6 className="card-title text-primary fw-semibold mb-3">
                              <i className="ti ti-user me-2" />
                              User Information
                            </h6>
                            <div className="row">
                              <div className="col-sm-4 text-muted">
                                User Name
                              </div>
                              <div className="col-sm-8 fw-medium">
                                {incentiveResult.user_name || "N/A"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Financial Details Card */}
                      <div className="col-12">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <h6 className="card-title text-primary fw-semibold mb-3">
                              <i className="ti ti-currency-rupee me-2" />
                              Financial Details
                            </h6>
                            <div className="row g-3">
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Salary</span>
                                  <span className="fw-medium">
                                    ₹
                                    {incentiveResult.salary?.toLocaleString(
                                      "en-IN"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Target</span>
                                  <span className="fw-medium">
                                    ₹
                                    {incentiveResult.target?.toLocaleString(
                                      "en-IN"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">
                                    Incentive Target
                                  </span>
                                  <span className="fw-medium">
                                    ₹
                                    {incentiveResult.incentive_target?.toLocaleString(
                                      "en-IN"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">
                                    Total Deal Value
                                  </span>
                                  <span className="fw-medium">
                                    ₹
                                    {incentiveResult.total_deal_value?.toLocaleString(
                                      "en-IN"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">
                                    Incentive %
                                  </span>
                                  <span className="fw-medium">
                                    {incentiveResult.incentive_percentage?.toFixed(
                                      2
                                    ) || "N/A"}
                                    %
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">
                                    Calculated Incentive
                                  </span>
                                  <span className="fw-medium">
                                    ₹
                                    {incentiveResult.calculated_incentive?.toLocaleString(
                                      "en-IN"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                              {incentiveResult.incentive_level && (
                                <div className="col-md-6">
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Incentive Level
                                    </span>
                                    <span className="fw-medium">
                                      {incentiveResult.incentive_level}
                                    </span>
                                  </div>
                                  {incentiveResult.created_at && (
                                    <div className="flex justify-between items-center">
                                      <span className="text-gray-600">
                                        Created At:{" "}
                                      </span>
                                      <span className="font-medium text-gray-900">
                                        {new Date(
                                          incentiveResult.created_at
                                        ).toLocaleString()}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Target Achieved Badge */}
                      {incentiveResult.total_deal_value >=
                        incentiveResult.target && (
                          <div className="col-12 text-center">
                            <span className="badge bg-success fs-6 px-4 py-3 shadow-sm">
                              <i className="ti ti-trophy me-2 fs-5" />
                              Target Achieved! Well Done!
                            </span>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="text-center py-5 text-muted">
                      <i className="ti ti-info-circle fs-1 mb-3" />
                      <p>No incentive data available for this user.</p>
                    </div>
                  )}
                </div>
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-secondary px-5"
                    onClick={() => {
                      setShowResultModal(false);
                      setCalculateUserId("");
                      setIncentiveResult(null);
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <ModalDeleteEffect />
        {/* Delete Target */}
        <div className="modal fade effect-modal-show" id="delete_target">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger fw-bold fw-semibold">
                  <i className="ti ti-alert-triangle me-2" />
                  Confirm Deletion
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-modal-pulse">
                  <i className="ti ti-trash fs-40 text-danger" />
                </div>
                <h4 className="fw-bold text-dark mb-3">Delete This Target?</h4>
                <p className="text-muted fs-15 mb-4 px-4">
                  This action <strong>cannot be undone</strong>. The target will
                  be <strong>permanently removed</strong>.
                </p>
                <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                  <i className="ti ti-info-circle me-2" />
                  <strong>Warning:</strong> This may affect incentive
                  calculations.
                </div>
                <div className="d-flex gap-3 justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light px-5 py-2 fw-medium"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger px-5 py-2 fw-medium"
                    onClick={handleConfirmDelete}
                    data-bs-dismiss="modal"
                    disabled={deleting}
                  >
                    {deleting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Deleting...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-trash me-2" />
                        Yes, Delete It
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      <div
        className="modal fade effect-modal-show"
        id="bulk_delete_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="bulkDeleteLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title text-danger fw-bold"
                id="bulkDeleteLabel"
              >
                <i className="ti ti-alert-triangle me-2" />
                Confirm Bulk Deletion
              </h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-modal-pulse">
                <i className="ti ti-trash fs-40 text-danger" />
              </div>
              <h4 className="fw-bold text-dark mb-3">
                Delete {selectedRows.length} Target
                {selectedRows.length > 1 ? "s" : ""}?
              </h4>
              <p className="text-muted fs-15 mb-4 px-4">
                This action <strong>cannot be undone</strong>. The selected
                targets will be
                <strong> permanently removed</strong> from your system.
              </p>
              <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                <i className="ti ti-info-circle me-2" />
                <strong>Warning:</strong> This may affect users currently using
                these targets.
              </div>
              <div className="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-light px-5 py-2 fw-medium"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger px-5 py-2 fw-medium"
                  onClick={handleBulkDelete}
                  data-bs-dismiss="modal"
                  disabled={deleting}
                >
                  {deleting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-trash me-2" />
                      Yes, Delete Permanently
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Column Order Modal */}
      <SaveModal />
      <ScrollToTop />
    </>
  );
};

export default TargetPage;
